import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () =>
        import(/* webpackChunkName: "home" */ '@/module/pages/Home'),
      children: [

        {
          path: '/CampSearch', // 快速查詢訂單頁
          name: 'CampSearch',
          component: () =>
            import(/* webpackChunkName: "CampSearch" */ '@/module/pages/CampSearch.vue')
        },
        {
          path: '/CampSearchResult/:date', // 搜尋結果頁
          name: 'CampSearchResult',
          component: () =>
            import(/* webpackChunkName: "CampSearchResult" */ '@/module/pages/CampSearchResult.vue')
        },
        {
          path: '/Booking/:isUser/:date/:id', // 快速訂位
          name: 'Booking',
          component: () =>
            import(/* webpackChunkName: "Booking" */ '@/module/pages/Booking.vue')
        },
        {
          path: '/OrderInfo/:isUser', // 訂單列表
          name: 'OrderInfo',
          component: () =>
            import(/* webpackChunkName: "OrderInfo" */ '@/module/pages/OrderInfo.vue')
        }
      ]
    }
  ]
})
